module.exports = __webpack_public_path__ + "img/28548308.30bc1470.png";